module.exports = __webpack_public_path__ + "static/axa-404b77e81687848d649d783d8b0e2014.png";